export const EventTypes = {
    COMPANY_DIARY: 'Agenda',
    COURSE: 'Curso',
    TALK: 'Auditorio',
    SURVEY: 'Encuesta'
};